'use strict'

/*
 * This module does the following:
 * 1. it implements the retry and timeout resiliency patterns
 */
const merge = require('deepmerge')
const axios = require('axios').default
const axiosRetry = require('axios-retry').default

axios.defaults.timeout = 10000

/**
 *
 * @param {Object} options `axios-retry` options to pass in.
 * @returns {AxiosInstance}
 */
const getRetryAxiosInstance = (options = {}) => {
    const retryConfig = merge({ retryDelay: axiosRetry.exponentialDelay }, options)
    const axiosRetryInstance = axios.create()
    axiosRetry(axiosRetryInstance, retryConfig)

    return axiosRetryInstance
}

module.exports = {
    axios,
    getRetryAxiosInstance
}
